// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverviewIndexedDataSummary from './OverviewIndexedDataSummary';
import OverviewAreaItem from './OverviewAreaItem';
// css
import '../../styles/components/analytics/Overview.scss';


class OverviewArea extends Component {

  renderAreas() {
    return this.props.subareas.map((subarea, index) => (
      <OverviewAreaItem
        key={index}
        area={this.props.area}
        subarea={subarea}
        stats={subarea.stats}
      />
    ));
  }

  render() {
    const { totalStats } = this.props;

    return (
      <div className='analytics__overview analytics__overview-area' id={this.props.pptxTarget}>
        <div className='row'>
          <div className='col-md-6 analytics__overview__titles'>
            <h2>Overview: {this.props.area.title}</h2>
            <h3>Indexing {totalStats.percentIndexed}% of required data</h3>
            <p>Based on key data sources identified by participants and required to acheive key goals</p>
          </div>
          <div className='col-md-6 analytics__overview__progress-bar-container'>
            <OverviewIndexedDataSummary
              indexedPerDayFormatter={indexedPerDay => `Indexing ${indexedPerDay}% of required data`}
              progressBarHeight={40}
              progressBarStripeColor='white'
              stats={totalStats}
            />
          </div>
        </div>
        <ul className='analytics__overview__area-list' >
          {this.renderAreas()}
        </ul>
      </div>
    );
  }
}

OverviewArea.propTypes = {
  area: PropTypes.object,
  subareas: PropTypes.array,
  totalStats: PropTypes.object,
  pptxTarget: PropTypes.string
};

export default OverviewArea;



// WEBPACK FOOTER //
// ./src/components/analytics/OverviewArea.js